export const LIST_PAGINATION_PROPS = {
  showSizeChanger: true,
  defaultPageSize: 10,
  pageSizeOptions: ['10', '25', '50', '100']
}

export const LIST_LOCALES_CELL_LIMIT = 5
